import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService, CommonUserService, Role } from '@fdm/services';
import { Observable } from 'rxjs';
import { ReportFormStore } from '../report-form.store';
import { ApprovalState, ApprovalUserRole, ReportType } from '@fdm/api-client';

@Injectable({ providedIn: 'root' })
export class UserRoleInterceptor implements HttpInterceptor {
  _store = inject(ReportFormStore);
  _user = inject(CommonUserService);
  _auth = inject(AuthService);

  tab = toSignal(this._store.page$);
  general = toSignal(this._store.general$);
  generalId = toSignal(this._store.generalTabId$);
  approvalFlow = toSignal(this._store.approvalFlow$);
  private defaultRole: ApprovalUserRole = ApprovalUserRole.Initiator;

  apiList = [
    'api/ActionItem',
    'api/GeneralTab',
    'api/EquipmentTab',
    'api/ApprovalFlow',
    'api/RiptTab',
    'api/RiskEvaluation',
    'api/ResolutionAndMitigationPlan',
    'api/FindingDescriptionTab',
    'api/NotesAndAttachments',
    'api/Reference'

  ];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const general = this.general();
    const tab = this.tab();

    const approvalData = this.approvalFlow();

    //add fastrepi role support
    if (this._auth.isInRole(Role.Creator) && this._auth.isInRole(Role.RIPTRisk)) {
      this.defaultRole = ApprovalUserRole.Initiator;
    }
    else if (this._auth.isInRole(Role.RIPTRisk)) {
      this.defaultRole = ApprovalUserRole.FastRepi;
    }

    const approvalUserRole = approvalData && general && tab ? this._user.getCurrentUserApprovalRoleV2(approvalData, general, tab) : this.defaultRole;

    if (this.apiList.some((api) => req.url.includes(api))) {
      let params = req.params;
      const isActionItemRequest = req.url.includes('api/ActionItem');
      const ownerEditableAIStates = [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.RIPTScored,
        ApprovalState.RiskEvaluationScored,
        ApprovalState.PlanConfirmed,
        ApprovalState.PlanEndorsed,
      ];
      const forceOwnerRoleForActionItems =
        isActionItemRequest &&
        general?.owner != undefined &&
        this._user.isEmailMatchingUser(general.owner) &&
        general?.reportType !== ReportType.AnomalyReport &&
        general?.currentState != undefined &&
        ownerEditableAIStates.includes(general.currentState);
      const initiatorEditableARStates = [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.PlanConfirmed,
      ];
      const forceInitiatorRoleForARActionItems =
        isActionItemRequest &&
        general?.initiator != undefined &&
        this._user.isEmailMatchingUser(general.initiator) &&
        general?.reportType === ReportType.AnomalyReport &&
        general?.currentState != undefined &&
        initiatorEditableARStates.includes(general.currentState);

      if (general?.id) {
        params = params.set('generalTabId', general.id);
      }


      // this is questionable
      if (!this._auth.isInRole(Role.Admin)) {
        const requestApprovalRole =
          forceOwnerRoleForActionItems ? ApprovalUserRole.Owner
            : forceInitiatorRoleForARActionItems ? ApprovalUserRole.Initiator
              : (approvalUserRole ?? this.defaultRole);
        params = params.set(
          'approvalUserRole',
          requestApprovalRole
        );
        // params = params.set('approvalUserRole', ApprovalUserRole.FastRepi);
      }

      const modifiedReq = req.clone({ params });

      return next.handle(modifiedReq);
    }

    return next.handle(req);
  }
}
